export default {
  namespaced: true,
  state: {
    primaryColor: "#3498db",
    secondaryColor: "#2ecc71",
  },
  mutations: {
    setPrimaryColor(state, color) {
      state.primaryColor = color;
    },
    setSecondaryColor(state, color) {
      state.secondaryColor = color;
    },
  },
  actions: {
    updatePrimaryColor({ commit }, color) {
      commit("setPrimaryColor", color);
    },
    updateSecondaryColor({ commit }, color) {
      commit("setSecondaryColor", color);
    },
  },
  getters: {
    getPrimaryColor: (state) => state.primaryColor,
    getSecondaryColor: (state) => state.secondaryColor,
  },
};
